import { FC, useMemo } from 'react';
import moment from 'moment-timezone';
import { TRootState } from '@store/index';
import { useSelector } from 'react-redux';

interface TzDateFormatterProps {
    date: Date;
    format: string;
}

const TzDateFormatter: FC<TzDateFormatterProps> = (props) => {
    const { date, format } = props;

    const { profile } = useSelector((state: TRootState) => state);

    const formattedDate = useMemo(() => {
        if (!date) return '-';

        const _date = moment(date).tz(profile.info.timezone);

        if (_date && _date.isValid()) return _date.format(format);

        return '-';
    }, [date, format, profile.info.timezone]);

    return <>{formattedDate}</>;
};

export default TzDateFormatter;
